import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row custom-card-width" }
const _hoisted_5 = { class: "card custom-card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "card-title" }, "Progress", -1)
const _hoisted_8 = { class: "progress" }
const _hoisted_9 = ["aria-valuenow"]
const _hoisted_10 = { class: "flex row" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "card custom-card m-auto",
  style: {"width":"300px","text-align":"center"}
}
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "card-title" }, "Staking account not found", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_Vault = _resolveComponent("Vault")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfigPane, { notVisible: _ctx.wallet }, null, 8, ["notVisible"]),
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "progress-bar",
                          role: "progressbar",
                          style: _normalizeStyle({ width: _ctx.farmAcc.gemsStaked/1555*100 + '%'}),
                          "aria-valuenow":  _ctx.farmAcc.gemsStaked/1555*100,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100"
                        }, _toDisplayString(_ctx.farmAcc.gemsStaked), 13, _hoisted_9)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Vault, {
                    key: _ctx.farmerAcc,
                    class: "mb-10",
                    vault: _ctx.farmerAcc.vault.toBase58(),
                    farmerState: _ctx.farmerState,
                    onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                    onAddGems: _ctx.addGems
                  }, null, 8, ["vault", "farmerState", "onSelectedWalletNft", "onAddGems"]),
                  _createVNode(_component_FarmerDisplay, {
                    key: _ctx.farmerAcc,
                    farm: 'CSopnTK6AV3m7nMweHVkYi2vLQMtwC2kyNoKMU5ASJYa',
                    farmAcc: _ctx.farmAcc,
                    farmer: _ctx.farmer,
                    farmerAcc: _ctx.farmerAcc,
                    reward: _ctx.availableA,
                    farmerState: _ctx.farmerState,
                    class: "mb-10",
                    onRefreshFarmer: _ctx.handleRefreshFarmer,
                    onClaim: _ctx.claim,
                    onBeginStaking: _ctx.beginStaking,
                    onEndStaking: _ctx.endStaking,
                    onAddGems: _ctx.addGems
                  }, null, 8, ["farmAcc", "farmer", "farmerAcc", "reward", "farmerState", "onRefreshFarmer", "onClaim", "onBeginStaking", "onEndStaking", "onAddGems"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("button", {
                      class: "btn btn-primary mt-2",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                    }, " Create New ")
                  ])
                ])
              ]))
        ]))
  ], 64))
}